import {useCAPIQuery} from '@github-ui/agent-sessions/hooks/useCAPIQuery'
import {fetchCAPI} from '@github-ui/agent-sessions/utils/fetch-capi'
import type {AutomationDetail} from '../types/automations-payload'

export const automationQueryKey = (owner: string, repo: string, automationId?: string) => [
  'automation',
  owner,
  repo,
  automationId,
]

export async function fetchAutomation(owner: string, repo: string, automationId: string): Promise<AutomationDetail> {
  const response = await fetchCAPI({path: `/agents/repos/${owner}/${repo}/automations/${automationId}`})
  const data: AutomationDetail = await response.json()
  return data
}

export function useAutomation({
  owner,
  repo,
  automationId,
  initialData,
}: {
  owner: string
  repo: string
  automationId?: string
  initialData?: AutomationDetail
}) {
  const {data, isLoading, isError} = useCAPIQuery<AutomationDetail>({
    queryKey: automationQueryKey(owner, repo, automationId),
    queryFn: () => {
      if (!automationId) {
        throw new Error('automationId is required')
      }
      return fetchAutomation(owner, repo, automationId)
    },
    initialData,
    enabled: !!automationId,
  })

  return {
    automation: data,
    isLoading,
    isError,
  }
}
